export default __webpack_public_path__ + "static/media/Punto_12_Finocchietti_ENG_Def.f0c7446f.aac";